import IconComponent from "icons/IconComponent";

import PhoneIcon from "./phone.svg";

export default (PhoneIcon as any) as IconComponent;
